export default function Marquee() {
  const phrases = [
    "FLY HIGHER",
    "MIND",
    "BODY",
    "SOUL",
    "OMNIMUSCLE",
    "INSPIRE CHANGE",
  ];
  const repeated = [...phrases, ...phrases, ...phrases, ...phrases];

  return (
    <div
      data-testid="marquee-banner"
      className="bg-[#2E1065] border-y-2 border-[#D4AF37] py-6 overflow-hidden"
    >
      <div className="marquee-track">
        {repeated.map((p, i) => (
          <span
            key={i}
            className="outline-text text-5xl md:text-7xl mx-8 inline-block"
          >
            {p} <span className="mx-4">🌈</span>
          </span>
        ))}
      </div>
    </div>
  );
}
